import React from 'react';
import "./animatedcheck.css";

const AnimatedCheck = () => {
    return (
        <svg id="checkmark-group" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path id="checkmark" d="M4.79 11.99 L10.11 17.31 L19.98 7.44"/>
        </svg>
    );
};

export default AnimatedCheck;
